import { useMemo } from 'react'
import { ActionsResolverType, ActionResolverFNType, ActionType } from '../types/advanced-grid.types'

type ActionsConfigType = { key: string; action?: ActionResolverFNType; icon?: string | undefined }[]

/**
 * This hook resolves the actions and returns
 * @param actions
 * @param actionsResolvers
 * @returns
 */
const useActionsConfig = (
    actions?: string | ActionType,
    actionsResolvers?: ActionsResolverType
): ActionsConfigType => {
    let actionsMap: string[] = []
    if (typeof actions === 'string') {
        actionsMap = actions?.split('|')
        if (actionsResolvers) {
            const resolved = useMemo(
                () =>
                    actionsMap.map((actionKey) => {
                        const { action, icon } = actionsResolvers[actionKey] || {}
                        return { key: actionKey, action, icon }
                    }),
                [actions]
            )
            return resolved
        } else {
            return []
        }
    } else if (Array.isArray(actions)) {
        return useMemo(
            () => actions.map(({ action, icon, key }) => ({ action, key, icon })),
            [actions]
        )
    } else {
        return []
    }
}

export default useActionsConfig
